import { Goal } from './goal.model.js';
export var SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
  SubscriptionStatus["PENDING"] = "PENDING";
  SubscriptionStatus["ACTIVE"] = "ACTIVE";
  SubscriptionStatus["PAST_DUE"] = "PAST_DUE";
  SubscriptionStatus["CANCELED"] = "CANCELED";
  SubscriptionStatus["EXPIRED"] = "EXPIRED";
  return SubscriptionStatus;
}(SubscriptionStatus || {});
export var CancelSubscriptionReason = /*#__PURE__*/function (CancelSubscriptionReason) {
  CancelSubscriptionReason[CancelSubscriptionReason["SavingMoney"] = 1] = "SavingMoney";
  CancelSubscriptionReason[CancelSubscriptionReason["DoesNotWorkForMe"] = 2] = "DoesNotWorkForMe";
  CancelSubscriptionReason[CancelSubscriptionReason["TooMuchEffort"] = 3] = "TooMuchEffort";
  CancelSubscriptionReason[CancelSubscriptionReason["Other"] = 4] = "Other";
  CancelSubscriptionReason[CancelSubscriptionReason["UnplannedPregnancy"] = 5] = "UnplannedPregnancy";
  CancelSubscriptionReason[CancelSubscriptionReason["NoLongerNeed"] = 6] = "NoLongerNeed";
  CancelSubscriptionReason[CancelSubscriptionReason["SwitchingToHormonalBC"] = 7] = "SwitchingToHormonalBC";
  CancelSubscriptionReason[CancelSubscriptionReason["PlannedPregnancyNoLongerNeed"] = 8] = "PlannedPregnancyNoLongerNeed";
  CancelSubscriptionReason[CancelSubscriptionReason["Admin"] = 9] = "Admin";
  CancelSubscriptionReason[CancelSubscriptionReason["ChangingPlans"] = 10] = "ChangingPlans";
  CancelSubscriptionReason[CancelSubscriptionReason["PromotedToStarCycler"] = 11] = "PromotedToStarCycler";
  CancelSubscriptionReason[CancelSubscriptionReason["Error"] = 12] = "Error";
  CancelSubscriptionReason[CancelSubscriptionReason["CancelledPending"] = 13] = "CancelledPending";
  CancelSubscriptionReason[CancelSubscriptionReason["CancelledRollingTrialRenewal"] = 14] = "CancelledRollingTrialRenewal";
  CancelSubscriptionReason[CancelSubscriptionReason["BillingIssue"] = 15] = "BillingIssue";
  CancelSubscriptionReason[CancelSubscriptionReason["UnableToGetPregnant"] = 16] = "UnableToGetPregnant";
  CancelSubscriptionReason[CancelSubscriptionReason["IapUserReasonUnknown"] = 17] = "IapUserReasonUnknown";
  CancelSubscriptionReason[CancelSubscriptionReason["DeclinedPriceIncrease"] = 18] = "DeclinedPriceIncrease";
  CancelSubscriptionReason[CancelSubscriptionReason["RetryFailure"] = 19] = "RetryFailure";
  CancelSubscriptionReason[CancelSubscriptionReason["AdminRevokeAccess"] = 20] = "AdminRevokeAccess";
  CancelSubscriptionReason[CancelSubscriptionReason["AdminCancelation"] = 21] = "AdminCancelation";
  CancelSubscriptionReason[CancelSubscriptionReason["ChatbotRevokeAccess"] = 22] = "ChatbotRevokeAccess";
  return CancelSubscriptionReason;
}(CancelSubscriptionReason || {});
export const goalSpecificCancellationReasonsMap = {
  [Goal.PLAN]: [CancelSubscriptionReason.PlannedPregnancyNoLongerNeed],
  [Goal.PREVENT]: [CancelSubscriptionReason.UnplannedPregnancy, CancelSubscriptionReason.SwitchingToHormonalBC, CancelSubscriptionReason.NoLongerNeed],
  [Goal.RECOVERY]: [],
  [Goal.PREGNANT]: [],
  [Goal.POSTPARTUM]: [],
  [Goal.PERIMENOPAUSE]: []
};
export const cancellationReasonsByGoal = goal => [CancelSubscriptionReason.SavingMoney, CancelSubscriptionReason.DoesNotWorkForMe, CancelSubscriptionReason.TooMuchEffort, ...(goal && goalSpecificCancellationReasonsMap[goal] || []), CancelSubscriptionReason.Other];